import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useT } from "@/i18n";
import { X } from "lucide-react";

export default function CookieConsent() {
  const [show, setShow] = useState(false);
  const { t, lang } = useT();

  useEffect(() => {
    try {
      if (window.localStorage.getItem("makario_cookie") !== "accepted") {
        const timer = setTimeout(() => setShow(true), 1400);
        return () => clearTimeout(timer);
      }
    } catch (e) {}
  }, []);

  const accept = () => {
    try { window.localStorage.setItem("makario_cookie", "accepted"); } catch (e) {}
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="cookie-banner rounded-2xl border backdrop-blur-xl shadow-2xl"
      style={{
        background: "rgba(12,14,20,0.92)",
        borderColor: "rgba(255,255,255,0.10)",
        color: "#fff",
      }}
    >
      <div className="flex items-start gap-4 p-5 md:p-6">
        <div className="flex-1 text-sm text-white/80 leading-relaxed">
          {lang === "id" ? (
            <>
              Kami menggunakan cookies untuk menganalisis kunjungan dan meningkatkan pengalaman Anda. Dengan melanjutkan, Anda menyetujui{" "}
              <Link to="/privacy" className="link-line text-white">Kebijakan Privasi</Link> kami.
            </>
          ) : (
            <>
              We use cookies to analyse visits and improve your experience. By continuing you agree to our{" "}
              <Link to="/privacy" className="link-line text-white">Privacy Policy</Link>.
            </>
          )}
        </div>
        <div className="flex items-center gap-2 flex-none">
          <button
            type="button"
            data-testid="cookie-accept"
            onClick={accept}
            className="px-4 py-2 rounded-full text-[0.65rem] font-mono uppercase tracking-[0.22em] transition-colors"
            style={{ background: "var(--violet)", color: "#fff" }}
            onMouseEnter={(e) => (e.currentTarget.style.background = "var(--violet-deep)")}
            onMouseLeave={(e) => (e.currentTarget.style.background = "var(--violet)")}
          >
            {lang === "id" ? "Terima" : "Accept"}
          </button>
          <button
            type="button"
            onClick={accept}
            aria-label="dismiss"
            className="w-8 h-8 grid place-items-center rounded-full text-white/60 hover:text-white"
          >
            <X size={14} />
          </button>
        </div>
      </div>
    </div>
  );
}
